import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'collections-add_collection_to_cart-click';

/**
 * Track FB Pixel and GTM for add collection to cart events
 */
export function trackCollectionsAddCollectionToCartClick(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'AddToCartCollection',
    googleTagManagerEvent: 'AddToCartCollection',
    pixelCustomDataParams,
  });
}
